import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "components/Tooltip";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { ReactNode, useRef } from "react";
import { cn } from "utils/ui";

function CopyToClipboard({
  children,
  value,
  className,
  onClick,
}: {
  value: string;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const { isCopiedTooltipVisible, copyToClipboard } = useCopyToClipboard(timeoutRef);
  return (
    <div className={cn("inline-flex flex-nowrap items-center space-x-1", className)}>
      {children}
      <button
        type="button"
        onClick={() => {
          copyToClipboard(value);
          onClick?.();
        }}
        aria-label="copy"
      >
        <ClipboardDocumentCheckIcon className="size-[16px] text-gray-400 hover:cursor-pointer hover:text-gray-900 dark:hover:text-gray-200" />
        <Tooltip isVisible={isCopiedTooltipVisible} label="Copied" />
      </button>
    </div>
  );
}

export default CopyToClipboard;
